import script from "./BillingOrderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingOrderCard.vue?vue&type=script&setup=true&lang=js"

import "./BillingOrderCard.vue?vue&type=style&index=0&id=2d1a865b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1a865b"]])

export default __exports__